import { Box, BrandIcon, Row, Text, Tooltip } from "@hightouch/htui";

import { useContentFits } from "src/hooks/use-content-fits";

type BrandLabelProps = {
  /** The brand's name, or a count when there are several. */
  label: string;
  /** Says what the brand applies to. */
  tooltip: string;
};

/** A brand's name after the brand icon, in muted text. The canvas header and the composer show their brand with it, so the two read as one thing. */
export function BrandLabel({ label, tooltip }: BrandLabelProps) {
  const { contentFits, ref } = useContentFits<HTMLElement>();
  return (
    <Tooltip
      // A cut-off name leads the tooltip, so the full name is still reachable.
      message={contentFits ? tooltip : `${label}. ${tooltip}`}
      placement="top"
    >
      <Row align="center" gap={1} minWidth={0} color="text.tertiary">
        <Box as={BrandIcon} boxSize={4} flexShrink={0} />
        <Text ref={ref} size="sm" color="text.tertiary" isTruncated>
          {label}
        </Text>
      </Row>
    </Tooltip>
  );
}
